import { ref } from 'vue'

// Posts state
export const contents = ref([])
export const currentPage = ref(1)
export const itemsPerPage = ref(15)
export const totalContents = ref(0)
export const pageCount = ref(0)
export const loading = ref(false)
export const sortBy = ref('')
export const sortOrder = ref('DESC')
export const searchQuery = ref('')
export const filters = ref({})

// Content inspection state
export const inspectedContentId = ref(null)
export const commentId = ref(null)
